import React from "react";
import "../Css/CTA.css";
import ctaBg from "../assets/cloths.avif"; // background image

const CTA = () => {
  return (
    <section
      className="cta"
      style={{ backgroundImage: `url(${ctaBg})` }}
    >
      <div className="cta-overlay"></div>

      <div className="cta-content">

        <div className="cta-text">
          <span>CONTACT FOR SERVICES</span>
          <h2>
            You Get Premium Maid Service <br />
            From Us!
          </h2>
        </div>

        <div className="cta-buttons">
          <button className="cta-btn green">
            <a href="/services">GET OUR SERVICES</a>
          </button>

          <button className="cta-btn red">
  <a href="/contact">CONTACT US NOW</a>
</button>

        </div>

      </div>
    </section>
  );
};

export default CTA;
